import { render, staticRenderFns } from "./WalletRecharge.vue?vue&type=template&id=20195510&scoped=true&"
import script from "./WalletRecharge.vue?vue&type=script&lang=js&"
export * from "./WalletRecharge.vue?vue&type=script&lang=js&"
import style0 from "./WalletRecharge.vue?vue&type=style&index=0&id=20195510&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20195510",
  null
  
)

export default component.exports